const selectors = {
  getIsOpenWmsModal: state => state.wmsPopup.get('isOpenWmsModal'),
  getCoordinatesToWmsIdentification: state =>
    state.wmsPopup.get('coordinatesToWmsIdentification')
};

export default selectors;
